module.exports = __webpack_public_path__ + "static/media/badge_health_1.cf7ff0e1.png";


//////////////////
// WEBPACK FOOTER
// ./src/icons/badges/badge_health_1.png
// module id = 485
// module chunks = 0